/** Active UI / URL language. English locale files remain as i18n fallback only. */
export const DEFAULT_UI_LANGUAGE = 'fr' as const;
export type UiLanguage = typeof DEFAULT_UI_LANGUAGE;

export function normalizeUiLanguage(lang?: string | null): UiLanguage {
  return lang === 'fr' ? 'fr' : DEFAULT_UI_LANGUAGE;
}

export function getPreferredLanguage(): UiLanguage {
  return DEFAULT_UI_LANGUAGE;
}
